<template>
    <div>
        <vs-card class="cstm_vx_card">
            <div class="flex flex-wrap justify-between items-center" slot="header">
                <h4>Invoice Details</h4>
                <div>
                  <!-- <vs-button @click="findComma">findComma</vs-button> -->
                    <vs-switch class="manual_invoice_switch" v-model="switch1">
                        <span slot="on">Internal Purchase</span>
                        <span slot="off">Client Purchase</span>
                    </vs-switch>
                </div>
            </div>
            <div>
                <form class="manual_invoice_form" v-if="switch1 == true">
                    <fieldset>
                        <legend>Internal Purchase</legend>
                        <vs-row class="items-center">
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">School's Name</label>
                                <vs-input class="w-full" type="text" v-model="schoolName" />
                            </vs-col>
                            <vs-col class="p-2" vs-type="flex"  vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">School's Phone</label>
                                <vs-input class="w-full" type="text" v-model="schoolPhone" />
                            </vs-col>
                            
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">School's Email</label>
                                <vs-input class="w-full" type="text" v-model="schoolEmail" />
                            </vs-col>

                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">Due Date</label>
                                <flat-pickr  :config="configdateTimePicker" v-validate="'required'" v-model="dueDate"  label="Date" class="w-full" />
                            </vs-col>

                            <vs-col class="p-2" vs-w="12">
                              <fieldset class="relative">
                                <legend class="cstm_unique_legend">
                                  <label class="required">Shipping Address</label>
                                  <a class="expand_anchor cursor-pointer" @click="expandingCollapse">
                                    <span class="expand_span" v-if="!expandCollapse">Expand and fill up details</span>
                                    <span class="collapse_span" v-else style="color: red;">Show Less</span>
                                  </a>
                                </legend>
                              
                                <!-- <vs-textarea class="w-full" v-model="schoolAddress"></vs-textarea> -->
                                <div class="cstm_unique_collapse" :class="[expandCollapse ? 'show' : '']">
                                  <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="address1" v-model="bill_address.address1" class="custom_Input" label="Address Line 1" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.address1')" class="text-danger">{{ errors.first('add.address1') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-model="bill_address.address2" class="custom_Input" label="Address Line 2" icon-pack="feather" icon="icon-edit-2" icon-after style="width:100%;" />
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="city" v-model="bill_address.city" label="City" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.city')" class="text-danger">{{ errors.first('add.city') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="zip" v-model="bill_address.zip" class="custom_Input" label="Postcode/Zip" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.zip')" class="text-danger">{{ errors.first('add.zip') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
                                        <span style="font-size:12px;">Country</span>
                                        <v-select v-model="bill_address.country_id" v-validate="'required'" :reduce="option => option.id" label="country_name" name="Country" :options="countryList" style="width:100%;"/>
                                        <span v-show="errors.has('add.Country')" class="text-danger">{{ errors.first('add.Country') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">

                                      <vs-input v-validate="'required'" name="state" v-model="bill_address.state" class="custom_Input" label="County/State" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.state')" class="text-danger">{{ errors.first('add.state') }}</span>
                                    </vs-col>
                                  </div>
                              </fieldset>
                            </vs-col>
                        </vs-row>
                        <!-- <vs-button icon-pack="feather" icon="icon-edit" class="edit_manual_invoice"></vs-button> -->
                    </fieldset>
                </form>

                <form class="manual_invoice_form" v-else>
                    <fieldset>
                        <legend>Internal Student</legend>
                        <vs-row>
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">Customer</label>
                                <v-select
                                class="w-full"
                                :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
                                :options="studentList"
                                :reduce="(option) => option.client_users_id"
                                v-model="selectedStudent"
                                name="Student Name"
                                data-vv-name="Student Name"
                                >
                                <template v-slot:selected-option="studentList">
                                   <img
                                  v-if="studentList.picture!=''"
                                  class="person-img rounded-full"
                                  :src="studentList.picture"
                                />
                                <img
                                  v-else
                                  class="person-img rounded-full"
                                  src="@/assets/images/pages/user-circle-solid.svg"
                                />
                                {{ studentList.first_name }}
                                {{ studentList.last_name }}
                                </template>
                                  <template v-slot:option="studentList">
                                <img
                                  v-if="studentList.picture!=''"
                                  class="person-img rounded-full"
                                  :src="studentList.picture"
                                />
                                <img
                                  v-else
                                  class="person-img rounded-full"
                                  src="@/assets/images/pages/user-circle-solid.svg"
                                />
                                {{ studentList.first_name }}
                                {{ studentList.last_name }}
                              </template>
                                </v-select>
                            </vs-col>
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">Email</label>
                                <vs-input class="w-full" v-model="studentEmail" type="text" />
                            </vs-col>
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">Phone No.</label>
                                <vs-input class="w-full" v-model="studentPhone" type="text" />
                            </vs-col>
                            <vs-col class="p-2" vs-type="flex" vs-lg="6" vs-sm="12" vs-w="12">
                                <label class="required">Due Date</label>
                                <flat-pickr  :config="configdateTimePicker" v-validate="'required'" v-model="dueDate" label="Date" class="w-full" />
                            </vs-col>
                            <vs-col class="p-2" vs-w="12">
                              <fieldset class="relative">
                                <legend class="cstm_unique_legend">
                                  <label class="required">Billing Address</label>
                                  <a class="expand_anchor cursor-pointer" @click="expandingbillingCollapse">
                                    <span class="expand_span" v-if="!expandbillCollapse">Expand and fill up details</span>
                                    <span class="collapse_span" v-else style="color: red;">Show Less</span>
                                  </a>
                                </legend>
                                <!-- <label class="required">Billing Address</label> -->
                                <!-- <vs-textarea class="w-full" v-model="studentBillAddress"></vs-textarea> -->
                                <div class="cstm_unique_collapse" :class="[expandbillCollapse ? 'show' : '']">
                                  <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="address1" v-model="bill_address.address1" class="custom_Input" label="Address Line 1" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.address1')" class="text-danger">{{ errors.first('add.address1') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-model="bill_address.address2" class="custom_Input" label="Address Line 2" icon-pack="feather" icon="icon-edit-2" icon-after style="width:100%;" />
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="city" v-model="bill_address.city" label="City" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.city')" class="text-danger">{{ errors.first('add.city') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="zip" v-model="bill_address.zip" class="custom_Input" label="Postcode/Zip" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.zip')" class="text-danger">{{ errors.first('add.zip') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
                                        <span style="font-size:12px;">Country</span>
                                        <v-select v-model="bill_address.country_id" v-validate="'required'" :reduce="option => option.id" label="country_name" name="Country" :options="countryList" style="width:100%;"/>
                                        <span v-show="errors.has('add.Country')" class="text-danger">{{ errors.first('add.Country') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">

                                      <vs-input v-validate="'required'" name="state" v-model="bill_address.state" class="custom_Input" label="County/State" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.state')" class="text-danger">{{ errors.first('add.state') }}</span>
                                    </vs-col>
                                  </div>
                              </fieldset>
                            </vs-col>
                             <vs-col class="p-2" vs-w="12">
                               <fieldset class="relative">
                                <legend class="cstm_unique_legend">
                                  <label class="required">Shipping To</label>
                                  <a class="expand_anchor cursor-pointer" @click="expandingshippingCollapse">
                                    <span class="expand_span" v-if="!expandshipCollapse">Expand and fill up details</span>
                                    <span class="collapse_span" v-else style="color: red;">Show Less</span>
                                  </a>
                                </legend>
                                <!-- <vs-textarea class="w-full" v-model="studentShipAddress"></vs-textarea> -->
                                <div class="cstm_unique_collapse" :class="[expandshipCollapse ? 'show' : '']">
                                  <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="address1" v-model="ship_address.address1" class="custom_Input" label="Address Line 1" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.address1')" class="text-danger">{{ errors.first('add.address1') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-model="ship_address.address2" class="custom_Input" label="Address Line 2" icon-pack="feather" icon="icon-edit-2" icon-after style="width:100%;" />
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="city" v-model="ship_address.city" label="City" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.city')" class="text-danger">{{ errors.first('add.city') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
                                        <vs-input v-validate="'required'" name="zip" v-model="ship_address.zip" class="custom_Input" label="Postcode/Zip" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.zip')" class="text-danger">{{ errors.first('add.zip') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
                                        <span style="font-size:12px;">Country</span>
                                        <v-select v-model="ship_address.country_id" v-validate="'required'" :reduce="option => option.id" label="country_name" name="Country" :options="countryList" style="width:100%;"/>
                                        <span v-show="errors.has('add.Country')" class="text-danger">{{ errors.first('add.Country') }}</span>
                                      </vs-col>
                                      <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">

                                      <vs-input v-validate="'required'" name="state" v-model="ship_address.state" class="custom_Input" label="County/State" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
                                        <span v-show="errors.has('add.state')" class="text-danger">{{ errors.first('add.state') }}</span>
                                    </vs-col>
                                  </div>
                               </fieldset>
                            </vs-col>
                        </vs-row>
                    </fieldset>
                </form>

                <vs-divider />

                <h5 class="mb-4">Items List</h5>
                <div class="table-responsive cstm_vuexy_table">
                    <table class="item_list_table">                        
                        <thead>
                            <tr>
                                <th style="min-width: 70px;"><label>Sl No.</label></th>
                                <th style="min-width: 160px;">
                                  <label class="required">Product / Service</label>
                                </th>
                                <th style="min-width: 250px;"><label>Description</label></th>
                                <th style="width: 120px;">
                                  <label class="required">Qty</label>
                                </th>
                                <th style="width: 150px">
                                  <label class="required">Unit Price</label>
                                </th>
                                <th style="width: 150px;"><label >Total Price</label></th>
                                <th style="width: 150px;"><label >Taxable</label></th>
                                <th style="width: 122px;"><label >Action</label></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item_list, index) in item_lists" :key="index">
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td v-if="($route.query.type === 'edit' && qb_invoice_id === null ) || (!quickbookConnected && $route.query.type === 'create')">
                                    <vs-input class="w-full" type="text" v-model="item_list.item_name"/>
                                </td>
                                <td v-if="($route.query.type === 'edit' && qb_invoice_id !== null ) || (quickbookConnected && $route.query.type === 'create')">
                                  <v-select
                                  style="min-width: 200px;"
                                  class="dropdown_h_100 w-full"
                                  label="name"
                                  placeholder="Choose Item"
                                  v-validate="'required'"
                                  :reduce="(option) => option.id"
                                  :options="qbItem"
                                  v-model="item_list.qb_item_id"
                                  :clearable="true"
                                  @input="getDetailsOfItem(index)"
                                >
                                <!-- v-bind:class="{ disabled: subjectDisabled }" @open="onOpen"
                                  @close="onClose"-->
                              
                                  <template #list-header>
                                    <!-- <li ref="load" class="loader" v-show="subjectMeta.has_next">
                                            Loading more subjects...
                                          </li> -->
                                    <li style="margin-left: 15px; cursor: pointer">
                                      <span
                                        @click.prevent="openItemModal(index)"
                                        style="color: rgba(var(--vs-primary), 1); margin-left: 3px"
                                        >Add New Item</span
                                      >
                                    </li>
                                  </template>
                                </v-select>
                                </td>
                                <td>
                                    <vs-textarea class="w-full mb-0" type="text" v-model="item_list.description"></vs-textarea>
                                </td>
                                <td>
                                    <vs-input class="w-full" type="number" min="0" @change="updateQuantity(index)" v-model="item_list.quantity" />
                                </td>
                                <td>
                                    <vs-input class="w-full" type="number" min="0" @change="updateQuantity(index)" v-model="item_list.unit_price" />
                                </td>
                                <td>
                                    <vs-input class="w-full" type="text" readOnly v-model="item_list.total" />
                                </td>
                                <td>
                                    <vs-checkbox class="w-full" v-model="item_list.is_taxable" @change="calculateGrandTotal" />
                                </td>
                                <td>
                                    <div class="flex">
                                        <vs-button color="danger" :disabled="index === 0" type="border" icon-pack="feather" @click="deleteRow(index)" icon="icon-trash" class="mx-1"></vs-button>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="item_lists.length == 0">
                                <td colspan="7" class="text-center">
                                    No Data Available
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <!-- <tr>
                                <th colspan="4"></th>
                                <th>Due Date</th>
                                <th><div class="flex item-center">
                                    <flat-pickr  :config="configdateTimePicker" v-validate="'required'" v-model="dueDate" placeholder="Select Date"  label="Date" class="w-full" /></div></th>
                                <th></th>
                            </tr> -->
                            <tr>
                                <th colspan="4"></th>
                                <th>Total Amount</th>
                                <th ><span v-if="calculateSubtotal !== 0" class="inline-block mr-1" v-html="currencyCode"></span>{{calculateSubtotal}}</th>
                                <th colspan="2"></th>
                            </tr>
                            <tr>
                                <th colspan="4"></th>
                                <th>
                                  <label class="required uppercase">Tax</label>
                                </th>
                                <th colspan="2">
                                    <div class="flex items-center">
                                        <vs-input v-if="($route.query.type === 'edit' && qb_invoice_id === null ) || (!quickbookConnected && $route.query.type === 'create')" type="number" min="0" class="w-full" @change="calculateGrandTotal" v-model="tax"/>
                                        <v-select v-if="($route.query.type === 'edit' && qb_invoice_id !== null ) || (quickbookConnected && $route.query.type === 'create')"
                                          style="min-width: 200px;"
                                          class="cstm_vue_select dropdown_h_100 w-full"
                                          :getOptionLabel="(item) => `${item.tax_rate_name} (${item.rate_value})`"
                                          placeholder="Choose Tax"
                                          v-validate="'required'"
                                          :reduce="(option) => option.tax_rate_id"
                                          :options="qbTax"
                                          v-model="qb_tax_id"
                                          :clearable="true"
                                          
                                        >
                                        <!-- v-bind:class="{ disabled: subjectDisabled }" @open="onOpen"
                                          @close="onClose"    @input="getDetailsOfItem(index)"-->
                                      
                                          <template #list-header>
                                            <!-- <li ref="load" class="loader" v-show="subjectMeta.has_next">
                                                    Loading more subjects...
                                                  </li> -->
                                            <li style="margin-left: 15px; cursor: pointer">
                                              <span
                                                @click.prevent="addTaxPopup = true"
                                                style="color: rgba(var(--vs-primary), 1); margin-left: 3px"
                                                >Add New Tax</span
                                              >
                                            </li>
                                          </template>
                                        </v-select>

                                        <span class="inline-block mx-2">%</span>
                                    </div>
                                </th>
                                <th></th>
                            </tr>
                            <tr>
                                <th colspan="4"></th>
                                <th>Grand Total</th>
                                <th ><span v-if="grandTotal !== null" class="inline-block mr-1" v-html="currencyCode"></span>{{grandTotal}}</th>
                                <th colspan="2"></th>
                            </tr>
                        </tfoot>
                    </table>
                    <div class="text-right mt-4">
                        <vs-button color="danger" type="border" class="mr-2" @click="deleteAllItems" v-if="item_lists.length > 1">Delete All Items</vs-button>
                        <vs-button @click="addNewRowItem">Add Item</vs-button> &nbsp;
                        <vs-button @click="saveInvoice" v-if="grandTotal !== null && dueDate !== ''">{{buttonName}}&nbsp;Invoice</vs-button>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-popup title="Add Item" :active.sync="addItemPopup">
          <vs-row class="mb-4">
            <label class="vs-input--label required">Item Name</label>
            <vs-input v-model="addedItemName" class="w-full" />
          </vs-row>
          <vs-row>
            <label class="vs-input--label">Description</label>
            <vs-textarea v-model="addedItemDescription" class="w-full"/>
          </vs-row>
          <!-- <vs-row>
            <vs-input  type="number" placeholder="Quantity" v-model="addedItemQuantity" class="p-2 w-full"/>
          </vs-row> -->
          <vs-row class="mb-4">
            <label class="vs-input--label required">Unit Price</label>
            <vs-input type="number" min="0" v-model="addedItemUnitPrice" class="w-full"/>
          </vs-row>
          <!-- <vs-row>
            <vs-input placeholder="Total" readOnly v-model="addedItemTotal" class="p-2 w-full" />
          </vs-row> -->
          <vs-row class="mb-4">
            <vs-checkbox v-model="addedItemTaxable" class="">Taxable</vs-checkbox>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
            <vs-button @click="addItemPopup = false" type="border" color="danger"
              >Cancel</vs-button
            >
            <vs-button
              v-if="showQbItemSaveButton"
              @click="saveQbItem"
              color="primary"
              type="filled"
              class="ml-2 vs-con-loading__container"
              >Save</vs-button
            >            
          </vs-row>
        </vs-popup>
        <vs-popup title="Add Tax" :active.sync="addTaxPopup">
          <vs-row class="mb-4">
            <label class="vs-input--label required">Tax Name</label>
            <vs-input v-model="addedTaxName" class="w-full" />
          </vs-row>
          <vs-row>
            <label class="vs-input--label required">Agency Name</label>
            <vs-textarea v-model="addedTaxAgency" class="w-full"/>
          </vs-row>
          <vs-row class="mb-4">
            <label class="vs-input--label">Rate</label>
            <vs-input type="number" min="0" v-model="addedTaxRate" class="w-full"/>
          </vs-row>
          <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
            <vs-button @click="addTaxPopup = false" type="border" color="danger"
              >Cancel</vs-button
            >
            <vs-button
              v-if="showQbTaxSaveButton"
              @click="saveQbTax"
              color="primary"
              type="filled"
              class="ml-2 vs-con-loading__container"
              >Save</vs-button
            >
          </vs-row>
        </vs-popup>
        <vs-popup class="addressModal"  title="Address" :active.sync="openAddressModal">
      <div>
        <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="address1" v-model="address1" class="custom_Input" label="Address Line 1" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
              <span v-show="errors.has('add.address1')" class="text-danger">{{ errors.first('add.address1') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-model="address2" class="custom_Input" label="Address Line 2" icon-pack="feather" icon="icon-edit-2" icon-after style="width:100%;" />
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="city" v-model="city" label="City" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
              <span v-show="errors.has('add.city')" class="text-danger">{{ errors.first('add.city') }}</span>
            </vs-col>
            <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
              <vs-input v-validate="'required'" name="zip" v-model="zip" class="custom_Input" label="Postcode/Zip" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
              <span v-show="errors.has('add.zip')" class="text-danger">{{ errors.first('add.zip') }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">
              <span style="font-size:12px;">Country</span>
              <v-select v-model="country" v-validate="'required'" :reduce="option => option.id" label="country_name" name="Country" :options="countryList" style="width:100%;"/>
              <span v-show="errors.has('add.Country')" class="text-danger">{{ errors.first('add.Country') }}</span>
            </vs-col>
            <vs-col :vs-xs="6" :vs-md="12" :vs-lg="12" class="p-2">

            <vs-input v-validate="'required'" name="state" v-model="state" class="custom_Input" label="County/State" icon-pack="feather" icon="icon-edit-2" icon-after  style="width:100%;" />
              <span v-show="errors.has('add.state')" class="text-danger">{{ errors.first('add.state') }}</span>
            </vs-col>

            <vs-button :disabled="!showAddressSaveButton" @click="saveAddress" color="primary" type="border">Save</vs-button>
      </div>
        </vs-popup>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import { GetCountryList, quickbooksStatus } from '@/api/common'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import {getSchoolDetails, createManualInvoice, showManualInvoice, qbItemList, createQbItem, createQbTax, QbListTax} from '@/api/manual-invoice'
import { shortStudentListApi } from '@/api/student'
export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      qb_tax_code_id: null,
      expandCollapse: false,
      expandbillCollapse: false,
      expandshipCollapse: false,
      addItemPopup: false,
      qbItem: [],
      qbTax: [],
      addTaxPopup: false,
      addedItemName: '',
      addedItemDescription: '',
      addedItemQuantity: null,
      addedItemUnitPrice: null,
      addedItemTotal: null,
      addedItemTaxable: false,
      addedTaxName: '',
      addedTaxAgency: '',
      addedTaxRate: null,
      getIndex: null,
      qb_tax_id: null,
      // qbMeta: {
      //   current_page: 1,
      //   has_next: true,
      //   limit: 20,
      //   next_page_url: '',
      //   previous_page_url: null,
      //   total: null
      // },
      // observer: new IntersectionObserver(this.loadMore),
      buttonName: 'Save',
      details: null,
      bill_address: {
        address1: '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        country_id: null
      },
      ship_address: {
        address1: '',
        address2: '',
        state: '',
        city: '',
        zip: '',
        country_id: null
      },
      address1: '',
      address2: '',
      zip: '',
      city: '',
      state: '',
      country: null,
      openAddressModal: false,
      dueDate: '',
      tax: null,
      grandTotal: null,
      configdateTimePicker: {
        enableTime: false,
        enableSeconds: true,
        dateFormat: 'Y-m-d',
        time_24hr: true,
        maxDate: '',
        minDate: new Date()
      },
      studentEmail: '',
      studentPhone: '',
      studentList: [],
      selectedStudent: null,
      currencyCode: JSON.parse(localStorage.getItem('localization'))
        .currency.currency_symbol,
      schoolName: JSON.parse(localStorage.getItem('customer_name')),
      quickbookConnected: false,
      schoolEmail: '',
      schoolPhone: '',
      schoolAddress: '',
      switch1:true,
      item_lists: [
        { 
          id: null,
          item_name: '',
          qb_item_id: null,
          description: '',
          quantity: null,
          unit_price: null,
          total: null,
          is_taxable: false
        }
      ],
      countryList: []
    }
  },
  mounted () {
    if (Object.keys(this.$route).length !== 0 && this.$route.constructor === Object) {
      if (this.$route.query.type === 'edit') {
        this.showManualInvoice(this.$route.query.id)
        this.buttonName = 'Update'
        const queryPayload = Object.assign({}, this.$route.query)
        this.$router
          .replace({ path: '/manual-invoice', query: queryPayload })
          .catch(() => {})
      } else if (this.$route.query.type === 'create') {
        const queryPayload = Object.assign({}, this.$route.query)
        this.buttonName = 'Save'
        this.$router
          .replace({ path: '/manual-invoice', query: queryPayload })
          .catch(() => {})
      }
    }
  },
  created () {
    this.fetchStatusForQuickbook()
    this.getSchoolDetails()
    this.fetchStudentList()
    this.fetchCountry()
    this.qbItemList()
    this.QbListTax()
  },
  computed: {
    showAddressSaveButton () {
      if (this.address1 !== '' && this.address2 !== '' && this.country !== null && this.city !== '' && this.state !== '' && this.zip !== '') {
        return true
      } else {
        return false
      }
    },
    showQbItemSaveButton () {
      if (this.addedItemName !== '' && this.addedItemUnitPrice !== null) {
        return true
      } else {
        return false
      }
    },
    showQbTaxSaveButton () {
      if (this.AddedTaxRate !== null && this.addedTaxAgency !== '' && this.addedTaxName !== '') {
        return true
      } else {
        return false
      }
    },
    calculateSubtotal () {
      let subtotal = 0
      this.item_lists.map(item => {
        subtotal += item.total
      })
      return subtotal
    }
  },
  watch: {
    switch1 () {
      if (this.switch1 === false) {
        this.bill_address.address1 = ''
        this.bill_address.address2 = ''
        this.bill_address.state = ''
        this.bill_address.city = ''
        this.bill_address.zip = ''
        this.bill_address.country_id = null
        this.ship_address.address1 = ''
        this.ship_address.address2 = ''
        this.ship_address.state = ''
        this.ship_address.city = ''
        this.ship_address.zip = ''
        this.ship_address.country_id = null
      }
    },
    addedItemQuantity () {
      this.addedItemTotal = this.addedItemQuantity * this.addedItemUnitPrice
    },
    addedItemUnitPrice () {
      this.addedItemTotal = this.addedItemQuantity * this.addedItemUnitPrice
    },
    qb_tax_id () {
      // if (this.$route.query.type !== 'edit') {
      if (this.qb_tax_id !== null) {
        const filterTax = this.qbTax.filter((item) => {
          return item.tax_rate_id === this.qb_tax_id
        })
        this.tax = filterTax[0].rate_value
        this.qb_tax_code_id = filterTax[0].tax_code_id
      }
      //}
      this.calculateGrandTotal()
    },
    tax () {
      if (!this.quickbookConnected) {
        this.calculateGrandTotal()
      }
    },
    calculateSubtotal () {
      //if (!this.quickbookConnected) {
      this.calculateGrandTotal()
      //}
    },
    selectedStudent () {
      if (this.selectedStudent !== null) {
        this.address1 = ''
        this.address2 = ''
        this.zip = ''
        this.city = ''
        this.state = ''
        this.country = null
        if (this.$route.query.type === 'create') {
          const filterStudent = this.studentList.filter((item) => {
            return item.client_users_id === this.selectedStudent
          })
          this.studentEmail = filterStudent[0].email
          this.studentPhone = filterStudent[0].mobile
          if (filterStudent[0].address.address1 === '' || filterStudent[0].address.zip === '' || filterStudent[0].address.country === '' || filterStudent[0].address.city === '') {
            this.openAddressModal = true
            this.warningPopupMessage('Please give your address first')
          } else {
            // this.studentBillAddress = `${filterStudent[0].address.address1  } , ${ filterStudent[0].address.city  } , ${filterStudent[0].address.country  } ,  ${  filterStudent[0].address.zip}`
            // this.studentShipAddress = `${filterStudent[0].address.address1  } , ${ filterStudent[0].address.city  } , ${filterStudent[0].address.country  } , ${  filterStudent[0].address.zip}`
            this.bill_address.address1 = filterStudent[0].address.address1
            this.bill_address.address2 = filterStudent[0].address.address2
            this.bill_address.state = filterStudent[0].address.state
            this.bill_address.city = filterStudent[0].address.city
            this.bill_address.zip = filterStudent[0].address.zip
            this.bill_address.country_id = filterStudent[0].address.country_id
            this.ship_address.address1 = filterStudent[0].address.address1
            this.ship_address.address2 = filterStudent[0].address.address2
            this.ship_address.state = filterStudent[0].address.state
            this.ship_address.city = filterStudent[0].address.city
            this.ship_address.zip = filterStudent[0].address.zip
            this.ship_address.country_id = filterStudent[0].address.country_id
          }
        } else {
          // this.studentBillAddress = `${this.details.bill_address.address1  }  , ${ this.details.bill_address.city  } , ${this.details.bill_address.country  }  , ${  this.details.bill_address.zip}`
          // this.studentShipAddress = `${this.details.ship_address.address1  } , ${ this.details.ship_address.city  } , ${this.details.ship_address.country  }  , ${  this.details.ship_address.zip}`

          this.bill_address.address1 = this.details.bill_address.address1
          this.bill_address.address2 = this.details.bill_address.address2
          this.bill_address.state = this.details.bill_address.state
          this.bill_address.city = this.details.bill_address.city
          this.bill_address.zip = this.details.bill_address.zip
          this.bill_address.country_id = this.details.bill_address.country_id
          this.ship_address.address1 = this.details.ship_address.address1
          this.ship_address.address2 = this.details.ship_address.address2
          this.ship_address.state = this.details.ship_address.state
          this.ship_address.city = this.details.ship_address.city
          this.ship_address.zip = this.details.ship_address.zip
          this.ship_address.country_id = this.details.ship_address.country_id
          
        }
        
      }
    }
  },
  methods: {
    async fetchStatusForQuickbook () {
      const { data } = await quickbooksStatus(localStorage.getItem('customer_id'))
      if (data.data[0] !== null) {
        this.quickbookConnected = data.data.status
      }
    },
    expandingCollapse () {
      this.expandCollapse = !this.expandCollapse
    },
    expandingbillingCollapse () {
      this.expandbillCollapse = !this.expandbillCollapse
    },
    expandingshippingCollapse () {
      this.expandshipCollapse = !this.expandshipCollapse
    },
    // findComma () {
    //   this.schoolAddress = this.schoolAddress.split(/[,]+/).join()
    // },
    // async onOpen () {
    //   if (this.qbMeta.has_next) {
    //     await this.$nextTick()
    //     this.observer.observe(this.$refs.load)
    //   }
    // },
    // onClose () {
    //   this.observer.disconnect()
    // },
    // async loadMore ([{isIntersecting, target}]) {
    //   if (isIntersecting) {
    //     const ul = target.offsetParent
    //     const scrollTop = target.offsetParent.scrollTop

    //     try {
    //       const response = await qbItemList(this.$store.getters.customerId, this.qbMeta.current_page + 1)
    //       this.qbItem.push(...response.data.data.items)
    //       this.qbMeta = response.data.data.meta
    //     } catch (e) {
    //       // 
    //     }
    //     await this.$nextTick()
    //     ul.scrollTop = scrollTop
    //   }
    // },
    openItemModal (index) {
      this.addItemPopup = true
      this.getIndex = index
    },
    async saveQbItem () {
      this.$vs.loading()
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          item_name: this.addedItemName,
          description: this.addedItemDescription,
          unit_price: this.addedItemUnitPrice,
          is_taxable: this.addedItemTaxable
        }
        const { data } = await createQbItem(payload)
        this.$vs.loading.close()
        this.addItemPopup = false
        const addedData = {
          description: data.data.item.description,
          id: data.data.item.id,
          is_taxable: data.data.item.is_taxable,
          name: data.data.item.name,
          type: data.data.item.type,
          unit_price: data.data.item.unit_price
        }
        this.qbItem.push(addedData)
        this.item_lists[this.getIndex].qb_item_id = data.data.item.id
        this.getDetailsOfItem(this.getIndex, data.data.item)
        this.addedItemName = ''
        this.addedItemDescription = ''
        this.addedItemUnitPrice = null
        this.addedItemTaxable = false
        this.successPopupMessage('Item added successfully')
      } catch (e) {
        this.warningPopupMessage('Something went wrong')
        this.$vs.loading.close()
      }
    },
    async saveQbTax () {
      this.$vs.loading()
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          tax_rate: this.addedTaxRate,
          tax_name: this.addedTaxName,
          tax_agency_name: this.addedTaxAgency
        }
        const { data } = await createQbTax(payload)
        this.$vs.loading.close()
        this.addTaxPopup = false
        const addedData = {
          rate_value: data.data.tax.rate_value,
          tax_agency_id: data.data.tax.tax_agency_id,
          tax_rate_id: data.data.tax.tax_rate_id,
          tax_rate_name: data.data.tax.tax_rate_name
        }
        this.qbTax.push(addedData)
        this.qb_tax_id = data.data.tax.tax_rate_id
        this.addedTaxRate = null
        this.addedTaxName = ''
        this.addedTaxAgency = ''
        this.successPopupMessage('Tax added successfully')
        
      } catch (e) {
        this.warningPopupMessage(e.message)
        this.$vs.loading.close()
      }
    },
    getDetailsOfItem (index, getdetails = null) {
      if (this.getIndex !== null && this.item_lists[this.getIndex].qb_item_id !== null && getdetails !== null) {
        this.item_lists[index].description = getdetails.description
        this.item_lists[index].unit_price = getdetails.unit_price
        this.item_lists[index].is_taxable = getdetails.is_taxable
        this.item_lists[index].item_name = getdetails.name
      } else if (index !== null && this.item_lists[index].qb_item_id !== null && getdetails === null) {
        const filterItem = this.qbItem.filter((item) => {
          return item.id === this.item_lists[index].qb_item_id
        })
        this.item_lists[index].description = filterItem[0].description
        this.item_lists[index].unit_price = filterItem[0].unit_price
        this.item_lists[index].is_taxable = filterItem[0].is_taxable
        this.item_lists[index].item_name = filterItem[0].name
      }
      
    },
    async qbItemList () {
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          qb_item_id: null
        }
        const { data } = await qbItemList(payload)
        this.qbItem = data.data.items
      } catch (e) {
        //
      }
    },
    async QbListTax () {
      try {
        const payload = {
          customer_id: this.$store.getters.customerId,
          qb_tax_id: null
        }
        const { data } = await QbListTax(payload)
        this.qbTax = data.data.items
      } catch (e) {
        //
      }
    },
    async showManualInvoice (id) {
      try {
        const { data } = await showManualInvoice(localStorage.getItem('customer_id'), id)
        this.details = data.data.invoice
        if (this.details.invoice_for !== 'SELF') {
          this.switch1 = false
          this.selectedStudent = this.details.user_details.user_id
          this.studentEmail = this.details.email
          this.studentPhone = this.details.phone
        } else {
          this.switch1 = true
          this.schoolEmail = this.details.user_details.email
          this.schoolPhone = this.details.user_details.phone
        }
        this.bill_address.address1 = this.details.bill_address.address1
        this.bill_address.address2 = this.details.bill_address.address2
        this.bill_address.state = this.details.bill_address.state
        this.bill_address.city = this.details.bill_address.city
        this.bill_address.zip = this.details.bill_address.zip
        this.bill_address.country_id = this.details.bill_address.country_id
        this.ship_address.address1 = this.details.ship_address.address1
        this.ship_address.address2 = this.details.ship_address.address2
        this.ship_address.state = this.details.ship_address.state
        this.ship_address.city = this.details.ship_address.city
        this.ship_address.zip = this.details.ship_address.zip
        this.ship_address.country_id = this.details.ship_address.country_id
        for (let index = 0; index < this.details.items.length - 1; index++) {
          this.addNewRowItem()
        }
        for (let index = 0; index < this.details.items.length; index++) {
          this.item_lists[index].id = this.details.items[index].id
          this.item_lists[index].item_name = this.details.items[index].item_name
          this.item_lists[index].description = this.details.items[index].description
          this.item_lists[index].quantity = this.details.items[index].quantity
          this.item_lists[index].unit_price = this.details.items[index].unit_price
          this.item_lists[index].total = this.details.items[index].total
          this.item_lists[index].qb_item_id = this.details.items[index].qb_item_id
          this.item_lists[index].is_taxable = this.details.items[index].is_taxable
        }
        this.qb_invoice_id = this.details.qb_invoice_id
        this.qb_tax_id = this.details.qb_tax_id
        this.tax = this.details.tax
        this.grandTotal = this.details.grand_total
        this.dueDate = this.details.due_date
        
      } catch (e) {}
    },
    saveAddress () {
      const filterCountry = this.countryList.filter((item) => {
        return item.id === this.country
      })
      console.log(filterCountry)
      if (this.switch1 === false) {
        // this.studentBillAddress = `${this.address1  } , ${this.address2  } , ${this.city  } , ${filterCountry[0].country_name  } , ${this.state  } , ${this.zip}`
        // this.studentShipAddress = `${this.address1  } , ${this.address2  } , ${this.city  } , ${filterCountry[0].country_name  } , ${this.state  } , ${this.zip}`

      } else {
        this.schoolAddress = `${this.address1  } , ${this.address2  } , ${this.city  } , ${filterCountry[0].country_name  } , ${this.state  } , ${this.zip}`
      }
      this.bill_address.address1 = this.address1
      this.bill_address.address2 = this.address2
      this.bill_address.state = this.state
      this.bill_address.city = this.city
      this.bill_address.zip = this.zip
      this.bill_address.country_id = this.country
      this.ship_address.address1 = this.address1
      this.ship_address.address2 = this.address2
      this.ship_address.state = this.state
      this.ship_address.city = this.city
      this.ship_address.zip = this.zip
      this.ship_address.country_id = this.country
      this.openAddressModal = false
    },
    addNewRowItem () {
      this.item_lists.push(
        {
          id: null,
          item_name: '',
          qb_item_id: null,
          description: '',
          quantity: null,
          unit_price: null,
          total: null,
          is_taxable: false
        }
      )
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {}
    },
    deleteRow (index) {
      this.item_lists.splice(index, 1)
    }, 
    updateQuantity (index) {
      this.item_lists[index].total = this.item_lists[index].quantity * this.item_lists[index].unit_price
    },
    successPopupMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    warningPopupMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
    },
    calculateGrandTotal () {
      if (this.tax !== null || this.qb_tax_id !== null) {
        let subtotal = 0
        this.item_lists.map(item => {
          if (item.is_taxable) {
            subtotal += (item.total * (this.tax / 100))
          }
        })
        this.grandTotal = subtotal + this.calculateSubtotal
      } else {
        this.tax = 0
        let subtotal = 0
        this.item_lists.map(item => {
          if (item.is_taxable) {
            subtotal += (item.total * (this.tax / 100))
          }
        })
        this.grandTotal = subtotal + this.calculateSubtotal
      }
    },
    deleteAllItems () {
      this.item_lists = []
    },
    async getSchoolDetails () {
      try {
        const payload = {
          user_id: JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id: localStorage.getItem('customer_id')
        }
        const data = await getSchoolDetails(payload)
        this.schoolEmail = data.data.data.email
        this.schoolPhone = data.data.data.phone
        if (data.data.data.address.address1 === '' || data.data.data.address.zip === '' || data.data.data.address.country === '' || data.data.data.address.city === '') {
          this.openAddressModal = true
          this.warningPopupMessage('Please give your address first')
        } else {
          this.schoolAddress = `${data.data.data.address.address1  } , ${data.data.data.address.address2  } , ${data.data.data.address.city  } , ${data.data.data.address.country  } , ${data.data.data.address.state  } , ${data.data.data.address.zip}`
          this.bill_address.address1 = data.data.data.address.address1
          this.bill_address.address2 = data.data.data.address.address2
          this.bill_address.state = data.data.data.address.state
          this.bill_address.city = data.data.data.address.city
          this.bill_address.zip = data.data.data.address.zip
          this.bill_address.country_id = data.data.data.address.country_id
          this.ship_address.address1 = data.data.data.address.address1
          this.ship_address.address2 = data.data.data.address.address2
          this.ship_address.state = data.data.data.address.state
          this.ship_address.city = data.data.data.address.city
          this.ship_address.zip = data.data.data.address.zip
          this.ship_address.country_id = data.data.data.address.country_id
        }
      } catch (e) {
        console.log(e)
      }
    },
    async fetchStudentList () {
      try {
        const { data } = await shortStudentListApi(localStorage.getItem('customer_id'))
        this.studentList = data.data.clientUser
      } catch (e) {
        //
      }
    },
    async saveInvoice () {
      this.$vs.loading()
      try {
        if (this.buttonName === 'Update') {
          this.editInvoice()
        } else {
          const payload = {
            id: null,
            qb_invoice_id: null,
            customer_id: localStorage.getItem('customer_id'),
            user_id: JSON.parse(localStorage.getItem('userInfo')).id,
            user_type: 1,
            email: this.schoolEmail,
            qb_tax_code_id: this.qb_tax_code_id,
            phone: this.schoolPhone,
            invoice_for: 'SELF',
            due_date: this.dueDate,
            tax: this.tax,
            qb_tax_id: this.qb_tax_id,
            grand_total: this.grandTotal,
            item: this.item_lists,
            bill_address: this.bill_address,
            ship_address: this.ship_address
          }
          if (this.switch1 === false) {
            payload.user_id = this.selectedStudent
            payload.user_type = 2
            payload.invoice_for = 'CLIENT'
            payload.email = this.studentEmail
            payload.phone = this.studentPhone
          }
          const { data } = await createManualInvoice(payload)
          this.$router.push({
            name: 'manual-invoice'
          }).catch(() => {})
          this.successPopupMessage('Invoice created successfully')
          this.$vs.loading.close()
        }
      } catch (e) {
        console.log(e.data)
        if (e.data.message === 'Validation Error') {
          this.warningPopupMessage('\'*\' Marked fields are required')
        } else {
          this.warningPopupMessage('Something went wrong')
        }
        this.$vs.loading.close()
      }
    },
    async editInvoice () {
      try {
        const payload = {
          id: this.details.invoice_id,
          qb_invoice_id: this.details.qb_invoice_id,
          customer_id: localStorage.getItem('customer_id'),
          user_id: JSON.parse(localStorage.getItem('userInfo')).id,
          user_type: 1,
          email: this.schoolEmail,
          phone: this.schoolPhone,
          invoice_for: 'SELF',
          due_date: this.dueDate,
          tax: this.tax,
          qb_tax_code_id: this.qb_tax_code_id,
          qb_tax_id: this.qb_tax_id,
          grand_total: this.grandTotal,
          item: this.item_lists,
          bill_address: this.bill_address,
          ship_address: this.ship_address
        }
        if (this.switch1 === false) {
          payload.user_id = this.selectedStudent
          payload.user_type = 2
          payload.invoice_for = 'CLIENT'
          payload.email = this.studentEmail
          payload.phone = this.studentPhone
        }
        const { data } = await createManualInvoice(payload)
        this.$router.push({
          name: 'manual-invoice'
        }).catch(() => {})
        this.successPopupMessage('Invoice Updated successfully')
        this.$vs.loading.close()
      } catch (e) {
        this.warningPopupMessage('Something went wrong')
        this.$vs.loading.close()
      }
    }
  }
}
</script>

<style>
.addressModal {
  z-index: 53002;
}
.manual_invoice_switch {
    min-width: 120px;
    height: 28px;
    border-radius: 20px;
}
.manual_invoice_switch.vs-switch-primary {
    background: rgba(var(--vs-secondary),1);
}
.manual_invoice_switch.vs-switch-primary.vs-switch-active {
    background: rgba(var(--vs-primary),1);
}
.manual_invoice_switch .vs-switch--circle {
    width: 25px;
    height: 25px;
}
.manual_invoice_switch.vs-switch.vs-switch-active .vs-switch--circle {
    margin-left: calc(100% - 28px);
}
.manual_invoice_switch .vs-switch--text {
    width: 100%;
    justify-content: flex-start;
    font-size: 12px;
}
.manual_invoice_switch .vs-switch--text.text-off {
    color: #fff;
    padding-left: 35px;
}
.manual_invoice_form fieldset {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 10px;
    position: relative;
}
.manual_invoice_form legend {
    padding: 10px;
}
.manual_invoice_form label {
    min-width: 140px;
}
.item_list_table textarea {
    height: 38.4px;
}
.edit_manual_invoice {
    position: absolute;
    top: -40px;
    right: -10px;
}
</style>